module.exports = __webpack_public_path__ + "img/SalamehGourmehStrore-Logo-black.5800ee19.png";